import { TrendingUp, Briefcase, Home, Code, BookOpen, Coins, Wrench } from "lucide-react";
import type { IncomeStream } from "@/hooks/useEventEngine";

const STREAM_ICONS: Record<string, React.ElementType> = {
  side_hustle: Briefcase,
  freelance: Code,
  business_income: TrendingUp,
  dividend_income: Coins,
  rental_income: Home,
  digital_product: BookOpen,
  royalty_income: Wrench,
};

interface IncomeStreamsCardProps {
  streams: IncomeStream[];
  multiplier: number;
}

const IncomeStreamsCard = ({ streams, multiplier }: IncomeStreamsCardProps) => {
  if (streams.length === 0) {
    return (
      <div className="glass-card p-5 space-y-2 opacity-60">
        <div className="flex items-center gap-2">
          <TrendingUp className="w-4 h-4 text-muted-foreground" />
          <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider">Income Streams</span>
        </div>
        <p className="font-heading font-bold text-lg text-muted-foreground">No Streams Yet</p>
        <p className="text-xs text-muted-foreground">Complete modules to unlock additional income streams and boost your earnings.</p>
      </div>
    );
  }

  return (
    <div className="glass-card p-5 space-y-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <TrendingUp className="w-4 h-4 text-primary" />
          <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider">Income Streams</span>
        </div>
        <span className="font-heading font-bold text-sm text-primary">{multiplier.toFixed(2)}x</span>
      </div>
      <p className="text-xs text-muted-foreground">
        Earnings multiplier applied to every correct answer
      </p>
      <div className="space-y-2">
        {streams.map((stream) => {
          const Icon = STREAM_ICONS[stream.stream_type] || Briefcase;
          return (
            <div key={stream.id} className="flex items-center gap-2.5 rounded-lg bg-muted/30 px-3 py-2">
              <Icon className="w-4 h-4 text-secondary shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-xs font-medium text-foreground truncate">{stream.stream_name}</p>
              </div>
              <span className="text-[10px] font-semibold text-primary">
                +{(stream.multiplier_bonus * 100).toFixed(0)}%
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default IncomeStreamsCard;
